/* eslint-disable max-len */
import axios from "axios";
import { useMemo, useState, useContext, useRef, useEffect } from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate } from "react-router-dom";
import AllCompetenciesList from "../../components/AllCompetenciesList";
import SearchCompetencies from "../../components/SearchCompetencies";
import { UserContext } from "../../context/UserContext";
import { VersionContext } from "../../context/VersionContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { CloneCompetencyModal } from "./CloneCompetencyModal";
import SnackBar from "../../components/SnackBar";
function ModifyCompetency() {
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const role = userContext.user.role;
  const roleId = userContext.user.id;
  const redirectExplore = () => {
    navigate("/view/pillars");
  };
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [searchResult, setSearchResult] = useState<any>("");
  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [defaultSearchText, setDefaultSearchText] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [resetSearch, setResetSearch] = useState<boolean>(false);
  const [totalRequiredCredits, setTotalRequiredCredits] = useState<
    number | null
  >(null);
  const [optionGroupCredits, setOptionGroupCredits] = useState<any>(null);
  const [totalCredits, setTotalCredits] = useState<any>(null);
  const { version } = useContext(VersionContext);
  const ref = useRef(null);
  const redirectToPillar = () => {
    navigate("/view/pillars");
  };
  const universityCode = localStorage.getItem("university");
  const searchCompetency = (keyword: string) => {
    localStorage.setItem("currentPillar", keyword);
    const found = filterArrayElementByCode(keyword);
    // if (found && found.id) {
    //   setSearchResult(found.id);
    // } else {
    //   setSnackbarOpen(true);
    //   setSearchResult('');
    // }
  };
  const currentPillar: any = localStorage.getItem("currentPillar");
  const [versionOption, setVersionOption] = useState([]);
  useEffect(() => {
    fetchCompetencies();
    versionOption?.length === 0 && fetchAllVersions();
    if (version.version_number === 0) {
      navigate("/curriculum/version");
    }
  }, []);
  useEffect(() => {
    scrollTo(ref);
    if (currentPillar) {
      setDefaultSearchText(currentPillar);
      searchCompetency(currentPillar);
    }
  }, [ref, competencies]);
  const fetchCompetencies = () => {
    setLoading(true);
    axios
      .get(
        `/competency/summary?university_code=${universityCode}&curriculum_version=${
          version.version_number
        }${role === "instructor" ? `&instructor_id=${roleId}` : ""}`
      )
      .then((res) => {
        if (res.data.competencies) {
          setCompetencies(res.data.competencies);
          setSearchResult("");
          setResetSearch(!resetSearch);
        }
        setLoading(false);
      })
      .catch(() => {
        setCompetencies([]);
        setLoading(false);
      });
  };

  const fetchAllVersions = () => {
    setLoading(true);
    axios
      .get(`/version?university_code=${universityCode}`)
      .then((res) => {
        if (res.data.versions) {
          const temp = res.data.versions
            .filter(
              (v: { version_number: number; status: string }) =>
                v?.version_number !== version.version_number &&
                v.status === "Draft"
            )
            .map(
              (v1: {
                display_version: string;
                version_number: number;
                program_name: string;
              }) => ({
                label: v1.program_name + " : " + v1.display_version,
                value: v1.version_number,
              })
            );
          setVersionOption(temp);
        }
      })
      .catch(() => {
        setVersionOption([]);
      });
  };
  console.log('===',versionOption)

  function filterArrayElementByCode(code: string) {
    const result = competencies.filter((item: any) =>
      item.competency_code.toLowerCase().includes(code.toLowerCase())
    );
    if (code.length === 3 && result?.length > 0) {
      const totalCount = result.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.credits;
      }, 0);

      const requiredCount = result.reduce((accumulator, currentValue) => {
        return currentValue.required
          ? accumulator + currentValue.credits
          : accumulator;
      }, 0);

      const modified = Array.from(
        result
          .reduce((map, item) => {
            if (item.option_group !== null) {
              map.set(item.option_group.option_group_id, item);
            }
            return map;
          }, new Map())
          .values()
      );
      const optinGroupCredits = modified?.reduce(
        (accumulator: any, currentValue: any) => {
          return currentValue?.option_group
            ? accumulator + currentValue?.option_group?.option_group_credit
            : accumulator;
        },
        0
      );
      setTotalCredits(totalCount);
      setOptionGroupCredits(optinGroupCredits || 0);
      setTotalRequiredCredits(requiredCount);
    } else {
      setTotalCredits(null);
      setOptionGroupCredits(null);
      setTotalRequiredCredits(null);
    }
    setSearchResult(result);
    return result;
    // return competencies.filter((element) => {
    //   return element.competency_code === code;
    // })[0];
  }
  const scrollTo = (ref: any) => {
    if (ref && ref.current /* + other conditions */) {
      ref.current.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };

  const [isCloneOpen, setIsCloneOpen] = useState(false);
  const [selectedCompetency, setSelectedCompetency] = useState<{
    competency_code: string;
    source_version: number;
    target_version: number;
  }>({ competency_code: "", source_version: 0, target_version: 0 });

  const [errorOpen, setErrorOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [message, setMessage] = useState("");
  const handleClone = (value: any) => {
    setIsCloneOpen(true);
    setSelectedCompetency(value);
  };

  const saveClone = (targetVersion: { label: string; value: number }) => {
    axios
      .post(`/competency/clone`, {
        competency_code: selectedCompetency?.competency_code,
        source_version: version.version_number,
        target_version: targetVersion?.value,
      })
      .then((res) => {
        setSuccessOpen(true);
        if (res.data.cloned) {
          setMessage(
            `The competency (${selectedCompetency?.competency_code}) cloned into ${targetVersion.label}`
          );
        }
        setIsCloneOpen(false)
      })
      .catch((error: any) => {
        setErrorOpen(true);
        setMessage(error.response.data.error);
      });
  };

  return (
    <>
      <SnackBar
        isOpen={errorOpen}
        setOpen={setErrorOpen}
        type="error"
        header="Error"
        message={message}
      />
      <SnackBar
        isOpen={successOpen}
        setOpen={setSuccessOpen}
        type="success"
        header="Success"
        message={message}
      />
      {isCloneOpen && (
        <CloneCompetencyModal
          versionOption={versionOption}
          isOpen={isCloneOpen}
          setOpen={setIsCloneOpen}
          saveClone={saveClone}
        />
      )}
      <SearchCompetencies
        totalCredits={totalCredits}
        totalRequiredCredits={totalRequiredCredits}
        optionGroupCredits={optionGroupCredits}
        defaultSearchText={defaultSearchText}
        mode="edit"
        onSearch={(keyword) => searchCompetency(keyword)}
        snackbarOpen={snackbarOpen}
        setSnackbarOpen={setSnackbarOpen}
        resetSearch={resetSearch}
      >
        {loading ? (
          <LoadingSpinner />
        ) : (
          <AllCompetenciesList
            onClone={(value: any) => handleClone(value)}
            navHeight={totalCredits ? "190px" : "0px"}
            mode="edit"
            fetchParent={fetchCompetencies}
            data={searchResult ? searchResult : competencies}
            searchId={searchResult}
            onSelect={(data: any) => {
              navigate(`/modify/competency/${data.competency_code}`);
            }}
          />
        )}
      </SearchCompetencies>
    </>
  );
}
export default ModifyCompetency;
